<template>
  <v-layout column>
    <span
      v-if="!hidePercent"
      class="qj-progress-bar__percent font-weight-bold"
      :style="percentStyle"
    >
      {{ percentValue }}%
    </span>

    <v-layout align-center>
      <v-flex xs12>
        <div class="qj-progress-bar__track" :style="trackStyle">
          <div class="qj-progress-bar__fill" :style="fillStyle">
            <span
              v-if="!hideProgressNumbers && progress > 0"
              class="qj-progress-bar__values caption white--text pr-3 text-no-wrap font-weight-bold"
            >
              {{ formattedProgress }}
            </span>
          </div>

          <span
            v-if="!hideProgressNumbers && total > 0"
            class="qj-progress-bar__values caption black--text pr-3 text-no-wrap font-weight-bold"
          >
            {{ formattedTotal }}
          </span>
        </div>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "ProgressBar",

  props: {
    color: {
      type: String,
      default: "",
    },
    progress: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    percent: {
      type: Number,
      default: null,
    },
    hidePercent: {
      type: Boolean,
      default: false,
    },
    hideProgressNumbers: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
  },

  computed: {
    resolvedColor() {
      if (this.color) return this.color;
      return this.$vuetify.theme.primary || "#1976D2";
    },

    percentValue() {
      if (this.percent !== null) {
        return Math.min(Math.max(this.percent, 0), 100);
      }
      if (!this.total || this.total <= 0) return 0;

      const raw = (this.progress / this.total) * 100;
      return Math.min(Math.round(raw * 100) / 100, 100);
    },

    resolvedHeight() {
      if (typeof this.height === "number") {
        return this.height + "px";
      }
      return this.height;
    },

    trackStyle() {
      return {
        height: this.resolvedHeight,
        borderRadius: this.resolvedHeight,
      };
    },

    fillStyle() {
      return {
        width: this.percentValue + "%",
        backgroundColor: this.resolvedColor,
        borderRadius: this.resolvedHeight,
        minWidth: this.percentValue > 0 ? "2px" : "0",
      };
    },

    percentStyle() {
      return {
        color: this.resolvedColor,
      };
    },

    formattedProgress() {
      return this.formatNumber(this.progress);
    },

    formattedTotal() {
      return this.formatNumber(this.total);
    },
  },

  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) {
        return "0";
      }
      return value.toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.qj-progress-bar__track {
  position: relative;
  background-color: #e0e0e0;
  box-shadow: inset 0 4px 8px -2px rgba(0, 0, 0, 0.18);
}

.qj-progress-bar__values {
  white-space: nowrap;
  line-height: 1;
  padding: 0 4px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.3;
}

.qj-progress-bar__percent {
  white-space: nowrap;
  line-height: 1;
}

.qj-progress-bar__fill {
  position: absolute;
  box-shadow: inset 0 -4px 8px -2px rgba(0, 0, 0, 0.22);
  z-index: 1;
  height: 100%;
  transition: width 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: end;
}
</style>
